import { HTMLAttributes, PropsWithChildren } from 'react'

import classNames from 'classnames'
import { StyleSheetManager } from 'styled-components'

import { isPropValid } from 'hsds/utils/react'

type Props = {
  className?: string
  scope?: string
} & HTMLAttributes<HTMLDivElement>

/**
 * Provides Styled Components with a scope to prefix before generated classNames.
 * Adding scope increases specificity.
 */
export function ScopeProvider({
  children = null,
  className,
  scope = '',
  ...restProps
}: PropsWithChildren<Props>) {
  return (
    <StyleSheetManager
      shouldForwardProp={runShouldForwardProp}
      namespace={`.${scope}`}
      {...restProps}
    >
      <div className={classNames(scope, className)}>{children}</div>
    </StyleSheetManager>
  )
}

// This implements the default behavior from styled-components v5, but with our own isPropValid function
// https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
export function runShouldForwardProp(propName: string, target: unknown) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}

export default ScopeProvider
